// Define the OneSignalOptions interface directly to avoid import issues
interface OneSignalOptions {
  appId: string;
  safari_web_id?: string;
  allowLocalhostAsSecureOrigin?: boolean;
  promptOptions?: {
    slidedown?: {
      prompts?: Array<{
        type: string;
        autoPrompt?: boolean;
        text?: {
          actionMessage?: string;
          acceptButton?: string;
          cancelButton?: string;
        }
      }>
    }
  };
  notifyButton?: {
    enable?: boolean;
    prenotify?: boolean;
    showCredit?: boolean;
    text?: {
      [key: string]: string;
    }
  };
  [key: string]: any;
}
import { isSSR } from '@/lib/isSSR';

// OneSignal App ID
export const ONESIGNAL_APP_ID = "a5a45208-7e2f-4d92-bf8c-07c1d8e8e5ff";
export const ONESIGNAL_SAFARI_WEB_ID = "web.onesignal.auto.4bf73218-3550-4659-982d-970270d14d2d";

// Default OneSignal configuration
export const getOneSignalConfig = (): OneSignalOptions => ({
  appId: ONESIGNAL_APP_ID,
  safari_web_id: ONESIGNAL_SAFARI_WEB_ID,
  allowLocalhostAsSecureOrigin: true,
  promptOptions: {
    slidedown: {
      prompts: [
        {
          type: "push",
          autoPrompt: false,
          text: {
            actionMessage: "Vuoi ricevere notifiche sui prezzi dell'oro e dell'argento?",
            acceptButton: "Consenti",
            cancelButton: "Non ora"
          }
        }
      ]
    }
  },
  notifyButton: {
    enable: true,
    prenotify: true,
    showCredit: false,
    text: {
      'dialog.blocked.message': 'Abilita le notifiche nelle impostazioni del browser',
      'dialog.blocked.title': 'Notifiche bloccate',
      'dialog.main.button.subscribe': 'Iscriviti',
      'dialog.main.button.unsubscribe': 'Disiscriviti',
      'dialog.main.title': 'Notifiche',
      'message.action.resubscribed': 'Sei iscritto alle notifiche',
      'message.action.subscribed': 'Grazie per l\'iscrizione!',
      'message.action.subscribing': 'Iscrizione in corso...',
      'message.action.unsubscribed': 'Non riceverai più notifiche',
      'message.prenotify': 'Clicca per ricevere notifiche',
      'tip.state.blocked': 'Notifiche bloccate',
      'tip.state.subscribed': 'Iscritto alle notifiche',
      'tip.state.unsubscribed': 'Iscriviti alle notifiche'
    }
  }
});

// Check if we're in a server-side rendering environment
export const isServerSide = (): boolean => {
  return isSSR();
};
